/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Volleyball(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M79.992,211.15229a96.03068,96.03068,0,0,0,136.27063-45.37936l.018.00767a96.04293,96.04293,0,0,1-110.80941,1.24026L80,211.13844Z"
        opacity={0.2}
      />
      <Path
        d="M80,211.13844a95.68885,95.68885,0,0,1-28.8588-25.57583l-.00047.00035a96.04294,96.04294,0,0,1,54.3306-96.58389L128,128Z"
        opacity={0.2}
      />
      <Path
        d="M80,44.86156A95.68887,95.68887,0,0,1,116.57872,32.657l-.00007-.00059a96.043,96.043,0,0,1,56.4788,95.34363L128,128Z"
        opacity={0.2}
      />
      <Circle
        cx={128}
        cy={128}
        r={96}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={80}
        y1={44.86156}
        x2={128}
        y2={128}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={80}
        y1={211.13844}
        x2={128}
        y2={128}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={224}
        y1={128}
        x2={128}
        y2={128}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M116.57865,32.65643a96.043,96.043,0,0,1,56.4788,95.34363"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M51.14073,185.563a96.04294,96.04294,0,0,1,54.3306-96.58389"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M216.28063,165.7806a96.04293,96.04293,0,0,1-110.80941,1.24026"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Volleyball;
